import { render, staticRenderFns } from "./conversation-chat-box.vue?vue&type=template&id=b003f70a&scoped=true&"
import script from "./conversation-chat-box.vue?vue&type=script&lang=js&"
export * from "./conversation-chat-box.vue?vue&type=script&lang=js&"
import style0 from "./conversation-chat-box.vue?vue&type=style&index=0&id=b003f70a&prod&lang=scss&scoped=true&"
import style1 from "./conversation-chat-box.vue?vue&type=style&index=1&id=b003f70a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b003f70a",
  null
  
)

export default component.exports